module.exports = __webpack_public_path__ + "img/being-creative-dark.3a788184.svg";